import React from "react";
import styles from "../appointmentFlow.module.css";

interface InlineNoticeProps {
  message?: string | null;
}

/**
 * Inline recovery notice for the appointment modal: a state the customer can
 * finish from, not a failure. Announced politely so a screen reader hears the
 * recovery copy; `InlineError` stays for dead ends (`role="alert"`).
 */
const InlineNotice: React.FC<InlineNoticeProps> = ({ message }) => {
  if (!message) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      aria-atomic="true"
      className={styles.inlineNotice}
    >
      {message}
    </div>
  );
};

export default InlineNotice;
